export default "__VITE_ASSET__af9f43b0__"